import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LoginButton } from '../../components/auth/LoginButton';

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  provider_unreachable: 'Google sign-in is temporarily unavailable. Wait a minute and try again.',
  state_invalid: 'Your sign-in session expired or started on a different site address. Start again from this page.',
  auth_canceled: 'Google sign-in was canceled before it finished.',
  access_denied: 'Google sign-in was denied. Use your school account and try again.',
  auth_failed: 'Google sign-in failed. Try again.',
  auth_error: 'Google sign-in failed. Try again.',
};

export const Login: React.FC = () => {
  const location = useLocation();
  const { loading, error } = useAuth();
  const authErrorCode = new URLSearchParams(location.search).get('auth_error');
  const oauthError = authErrorCode ? OAUTH_ERROR_MESSAGES[authErrorCode] ?? OAUTH_ERROR_MESSAGES.auth_error : null;
  const displayError = oauthError ?? error;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100">
            <svg className="h-8 w-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to Hibbardsclass
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Your modern learning platform
          </p>
        </div>
        
        <div className="mt-8">
          <div className="bg-white py-8 px-6 shadow rounded-lg">
            <div className="space-y-4">
              <div className="text-center">
                <p className="text-sm text-gray-600 mb-4">
                  Use your school account to sign in
                </p>
                <LoginButton />
              </div>
              
              {displayError && (
                <div className="mt-4 text-center">
                  <p className="text-sm text-red-600">{displayError}</p>
                </div>
              )}
              
              {loading && (
                <div className="mt-4 text-center">
                  <p className="text-sm text-gray-500">Checking authentication...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
